import "./ContactsForm.scss";
import CustomInput from "../CustomInput/CustomInput";
import CustomTextarea from "../CustomTextarea/CustomTextarea";
import Button from "../Button/Button";
import Icon from "../Icon/Icon";
import ModalResponse from "../ModalResponse/ModalResponse";
import useForm from "../../Hooks/useForm";

const ContactsForm = ({ closeForm }) => {
  const { formData, handleChange, handleClick, modal, closeModal, loading, errors } = useForm();

  return (
    <>
      <form className="contacts-form" action="#">
        <fieldset className="contacts-form__fieldset">
          <legend className="contacts-form__legend visually-hidden">
            Личные данные
          </legend>
          <CustomInput
            type="text"
            id="name"
            name="name"
            label="Имя"
            value={formData.name}
            onChange={handleChange}
            error={errors.name}
          />
          <CustomInput
            type="email"
            id="email"
            name="email"
            label="Email"
            value={formData.email}
            onChange={handleChange}
            error={errors.email}
          />
        </fieldset>
        <fieldset className="contacts-form__fieldset">
          <legend className="contacts-form__legend visually-hidden">
            Сообщение
          </legend>
          <CustomTextarea
            id="message"
            name="message"
            label="Сообщение"
            value={formData.message}
            onChange={handleChange}
            error={errors.message}
          />
        </fieldset>
        <Button
          className="contacts-form__btn"
          content={
            <>
              <span className="btn__text">
                {loading ? "Отправка..." : "Отправить сообщение"}
              </span>
              <Icon
                className="btn__icon"
                id="icon-send"
                width="22"
                height="22"
              />
            </>
          }
          disabled={loading}
          handleClick={handleClick}
        />
      </form>

      <ModalResponse
        isOpen={modal.isOpen}
        message={modal.message}
        onClose={closeModal}
        title={modal.title}
        closeForm={closeForm}
      />
    </>
  );
};

export default ContactsForm;